<template>
  <u-page>
    <div slot="content">
      <div class="list">
        <a @click="click(1)">发起作业useID:{{userID}} homeworkID:{{homeworkID}}</a>
        <a @click="click(2)">老师查看作业列表useID:{{userID}} homeworkID:{{homeworkID}}</a>
        <a @click="click(3)">老师查看作业详情useID:{{userID}} homeworkID:{{homeworkID}}</a>
        <a @click="click(4)">学生查看作业useID:{{userID}} homeworkID:{{homeworkID}}</a>
        <a @click="click(5)">学生写作业useID:{{userID}} homeworkID:{{homeworkID}}</a>
        <a @click="click(6)">分享作业useID:{{userID}} homeworkID:{{homeworkID}}</a>
        <a @click="click(7)">查重useID:{{userID}} homeworkID:{{homeworkID}}</a>
        <a @click="click(8)">资源详情useID:{{userID}} homeworkID:{{homeworkID}}</a>
      </div>

      <div class="form">
        <label class="">
          userID
          <input type="Number" v-model="userID">
        </label>
        <label>
          活动ID
          <input type="Number" v-model="homeworkID">
        </label>
        <label>
          查重使用studentID
          <input type="Number" v-model="studentID">
        </label>
        <label>
          userName
          <input type="String" v-model="userName">
        </label>
      </div>
      <div>
        <button @click="submitClick">登陆</button>
      </div>

    </div>

  </u-page>

</template>

<script type="text/ecmascript-6">
  import UPage from 'common/components/u-page'
  import UlAudioTag from 'common/components/universal/ulAudioTag/ulAudioTag'
  import { mapActions } from 'vuex'
  import { creatCustomHttpTool } from 'common/js/httpTool'

  export default {
    data () {
      return {
        userID: '708215',
        homeworkID: '129',
        studentID: 552752,
        userName: 'huangqiantea'
      }
    },
    created () {
    },
    methods: {
      submitClick: function () {
        let params = {
          loginName: this.userName,
          password: '05d1ec61604b21ea890bfe17958ee909'
        }
        creatCustomHttpTool().post('https://apps.tongshike.cn/login', null, params).then((res) => {
          console.log('成功了')
          document.cookie = `token=${res.token}`
        }, () => {
        })
      },
      onDeviceReady: function () {
        console.log(window.cordova)
      },
      click: function (type) {
        if (type === 1) {
//          Uloading.showToast(new Vue(), {
//            content: 'sdfsdfsdf'
//          })
//          发起作业
          this.$router.push(`publishTea/${this.userID}/${this.homeworkID}`)
        } else if (type === 2) {
//         老师查看作业列表
          this.$router.push(`teaModifyList/${this.userID}/${this.homeworkID}`)
        } else if (type === 3) {
//          老师查看作业详情
          this.$router.push('publishTea')
        } else if (type === 4) {
//          学生查看作业
          this.$router.push(`stuDetail/${this.userID}/${this.homeworkID}`)
        } else if (type === 5) {
          this.$router.push(`stuWriting/${this.userID}/${this.homeworkID}`)
        } else if (type === 6) {
          this.$router.push(`shareWork/${this.userID}/${this.homeworkID}`)
        } else if (type === 7) {
          this.$router.push(`repeatReport/${this.userID}/${this.homeworkID}/552752`)
        } else if (type === 8) {
          this.setAttach({
            fileType: 'ppt',
            filePath: '/homework/0/1044140/59e5fa1e-c50c-4bc7-940c-e2c45c88f9c3.ppt',
            fileName: 'ppt.xls',
            fileSize: '19456'
          })
          this.$router.push(`attachDetail`)
        }
      },
      ...mapActions([
        'setAttach'
      ])
    },
    components: {
      UPage,
      UlAudioTag
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .list
    > a
      display: inline-block
      width: 100%
      height: 44px
      font-size: 18px

  .form
    label
      display: inline-block
      width: 100%
    input
      border-bottom: 1px solid
</style>



// WEBPACK FOOTER //
// src/common/components/start.vue